module.exports = __webpack_public_path__ + "static/media/two.4331fbbf.png";